function ModalDefault({ isOpen, onClose, children }) {
  if (!isOpen) return null;

  return (
    <div className="fixed z-[9999] inset-0 overflow-y-auto flex items-center justify-center p-4">
      <div className="fixed inset-0 transition-opacity duration-300">
        <div
          className="absolute inset-0 bg-gray-700 opacity-75"
          onClick={onClose}
        ></div>
      </div>

      <div className="relative transform transition-all duration-300 w-full max-w-5xl flex items-center justify-center">
        {children}
      </div>
    </div>
  );
}

export default ModalDefault;
